export default "__VITE_PUBLIC_ASSET__5f4c008e__"